export default "__VITE_ASSET__CTFiSCX$__"